import { Box, FormGroup, Grid, Modal, Typography, Stack, IconButton } from "@mui/material";
import Crossicon from "../../Icon/Crossicon";
import { apiErrorMessage } from "../../helper/apiError";
import { fontSize } from "../theme/fontSize";
import { fontWeight } from "../theme/fontWeight";
import { FontFamily } from "../theme/fontFamily";
import { ThemeColor } from "../theme/color";
import { Formik, Form } from "formik";
import CustomButton from "../button/button";
import OutlinedInputField from "../inputfiled/OutlinedInput";
import * as Yup from "yup";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetFilteredUserAction,
  GetUserChatAction,
} from "../../Redux/action/SettingAction";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import CustomSelect from "../select field/OutlinedSelectField";
import {
  AddGroupChatService,
  AddPersonChatService,
  AddPersonToGroupChatService,
} from "../../Redux/service/SettingService";
import CustomizedFilterAutoComplete from "../autocomplete/FilterAutocomplete";
import MultiSelectAutocomplete from "../autocomplete/FilterAutocomplete";
import { createUserNotificationAPI } from "../../Redux/service/notificationService";
import Previews from "../dropzone/Mydropzone";

import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { Editor } from "react-draft-wysiwyg";
import {
  convertToRaw,
  convertFromHTML,
  ContentState,
  EditorState,
} from "draft-js";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: "80%", md: "600px", lg: "700px" },
  maxHeight: "90vh",
  height: "auto",
  overflow: "auto",
  bgcolor: "background.paper",
  borderRadius: "16px",
  boxShadow: "0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)",
  p: 4,
  outline: "none",
  '&::-webkit-scrollbar': { width: '6px' },
  '&::-webkit-scrollbar-track': { background: 'transparent' },
  '&::-webkit-scrollbar-thumb': { background: '#CBD5E1', borderRadius: '10px' },
  '&::-webkit-scrollbar-thumb:hover': { background: '#94A3B8' },
};

export const AddPersonToNotificationModal = ({
  AddPersonNotification,
  handleClose,
  selectedUser,
}) => {
  const dispatch = useDispatch();
  const childRef = useRef(null);
  //   const [Participantlist, setParticipantlist] = useState([]);

  const [formLoading, setFormLoading] = useState(false);

  const [b_description, setB_Description] = useState();
  const [editorState, setEditorState] = useState("");

  const [filteredUser, setFilteredUser] = useState([]);

  const FilteredUserlistState = useSelector(
    (state) => state.setting?.filteredUser?.data?.users
  );

  useEffect(() => {
    const updatedData = FilteredUserlistState?.map(
      ({ firstName, ...rest }) => ({
        title: firstName,
        ...rest,
      })
    ).filter((data) => data._id !== window.sessionStorage.getItem("user_id"));
    setFilteredUser(updatedData);
  }, [FilteredUserlistState]);

  useEffect(() => {
    dispatch(GetFilteredUserAction());
  }, []);

  const validationSchemaGroup = Yup.object({
    text: Yup.string().required("Text is required"),
    title: Yup.string().required("Tittle is required"),

    selectedOptions: Yup.array()
      .required("Please select at least one option")
      .min(1, "Minimum one participant is required to create a group."),
  });

  return (
    <Modal
      open={AddPersonNotification}
      onClose={() => {
        handleClose();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {/* Modal Header */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
          <Typography
            fontFamily={FontFamily.Poppins}
            fontWeight={fontWeight.W700}
            fontSize="1.25rem"
            color={ThemeColor.NAVYBLUE}
          >
            Send Notification to User
          </Typography>
          <IconButton
            onClick={handleClose}
            sx={{
              color: "#94A3B8",
              transition: "all 0.2s",
              "&:hover": {
                color: "#EF4444",
                backgroundColor: "#FEF2F2"
              }
            }}
          >
            <Crossicon width="18" height="18" />
          </IconButton>
        </Box>

        <Formik
          initialValues={{
            title: selectedUser ? selectedUser.title : "",
            text: selectedUser ? selectedUser.text : "",
            selectedOptions: selectedUser ? [selectedUser._id] : [],
            images: [],
          }}
          validationSchema={validationSchemaGroup}
          onSubmit={async (values, { resetForm }) => {
            setFormLoading(true);
            let userIds = [];

            if (values.images.length > 0) {
              console.log("fkrfnrnferf");
              values["attachmentUrl"] = [values?.images?.[0]?.url];
            }
            delete values.images;
            if (values.selectedOptions) {
              values.selectedOptions?.map((data) => {
                userIds.push(data._id);
              });
            }

            let payload = {
              title: values.title,
              text: values.text,
              userIds: userIds,
              attachmentUrl: values.attachmentUrl,
            };
            console.log(payload);

            await createUserNotificationAPI(payload)
              .then((res) => {
                if (res.status === 200) {
                  dispatch(GetUserChatAction());
                  setFormLoading(false);
                  handleClose();
                  dispatch(showSnackbar(res.data.message, "success"));
                  resetForm();
                }
              })
              .catch((e) => {
                setFormLoading(false);
                dispatch(showSnackbar(apiErrorMessage(e), "error"));
              });
          }}
        >
          {({
            values,
            errors,
            handleBlur,
            handleChange,
            touched,
            handleSubmit,
            setFieldValue,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Stack spacing={2.5}>
                {/* Title */}
                <Box>
                  <Typography
                    fontFamily={FontFamily.Poppins}
                    fontSize="0.875rem"
                    fontWeight={600}
                    color="#475569"
                    sx={{ mb: 1 }}
                  >
                    Notification Title
                  </Typography>
                  <OutlinedInputField
                    value={values.title}
                    name="title"
                    onChange={handleChange}
                    placeholder="Enter title"
                    fullWidth={true}
                    helperText={
                      errors.title && touched.title ? (
                        <Typography
                          color={ThemeColor.RED}
                          fontSize="0.75rem"
                          fontFamily={FontFamily.Lato}
                          fontWeight={500}
                          sx={{ mt: 0.5 }}
                        >
                          {errors.title}
                        </Typography>
                      ) : null
                    }
                  />
                </Box>

                {/* Text Editor */}
                <Box>
                  <Typography
                    fontFamily={FontFamily.Poppins}
                    fontSize="0.875rem"
                    fontWeight={600}
                    color="#475569"
                    sx={{ mb: 1 }}
                  >
                    Notification Text
                  </Typography>
                  <Box
                    sx={{
                      border: "1px solid #E2E8F0",
                      borderRadius: "10px",
                      overflow: "hidden",
                      backgroundColor: "#F8FAFC",
                      transition: "border-color 0.2s ease, box-shadow 0.2s ease",
                      "&:focus-within": {
                        borderColor: ThemeColor.LIGHTPURPLE,
                        boxShadow: `0 0 0 3px ${ThemeColor.LIGHTPURPLE}15`,
                        backgroundColor: "#FFFFFF",
                      },
                      "& .rdw-editor-toolbar": {
                        border: "none",
                        borderBottom: "1px solid #E2E8F0",
                        background: "#F1F5F9",
                        p: "8px 12px",
                        m: 0
                      },
                      "& .rdw-editor-main": {
                        padding: "12px 16px",
                        minHeight: "150px",
                        maxHeight: "220px",
                        overflowY: "auto",
                        backgroundColor: "inherit",
                        fontSize: "0.95rem",
                        fontFamily: FontFamily.Lato
                      }
                    }}
                  >
                    <Editor
                      editorState={editorState}
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="wrapperClassName"
                      editorClassName="editorClassName"
                      placeholder="Enter notification text"
                      onEditorStateChange={(e) => setEditorState(e)}
                      onChange={(e) => {
                        const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
                        setB_Description(html);
                        setFieldValue("text", html);
                      }}
                    />
                  </Box>
                  {errors.text && touched.text && (
                    <Typography
                      color={ThemeColor.RED}
                      fontSize="0.75rem"
                      fontFamily={FontFamily.Lato}
                      fontWeight={500}
                      sx={{ mt: 0.5 }}
                    >
                      {errors.text}
                    </Typography>
                  )}
                </Box>

                {/* Recipients select */}
                <Box>
                  <Typography
                    fontFamily={FontFamily.Poppins}
                    fontSize="0.875rem"
                    fontWeight={600}
                    color="#475569"
                    sx={{ mb: 1 }}
                  >
                    Recipients
                  </Typography>
                  <MultiSelectAutocomplete
                    options={filteredUser}
                    label="Select users..."
                    filtertext={true}
                    value={values.selectedOptions}
                    onChange={(newValue) => {
                      setFieldValue("selectedOptions", newValue);
                    }}
                  />
                  {errors.selectedOptions && touched.selectedOptions && (
                    <Typography
                      color={ThemeColor.RED}
                      fontSize="0.75rem"
                      fontFamily={FontFamily.Lato}
                      fontWeight={500}
                      sx={{ mt: 0.5 }}
                    >
                      {errors.selectedOptions}
                    </Typography>
                  )}
                </Box>

                {/* Attachment */}
                <Box>
                  <Typography
                    fontFamily={FontFamily.Poppins}
                    fontSize="0.875rem"
                    fontWeight={600}
                    color="#475569"
                    sx={{ mb: 1 }}
                  >
                    Attachment (Optional)
                  </Typography>
                  <Previews
                    deleteShow={true}
                    mainText="Upload Attachment"
                    text="Any type of file can be selected."
                    ref={childRef}
                    initialValue={values?.images}
                    handleMydropzoneFile={(updatedFiles) => {
                      setFieldValue("images", updatedFiles);
                    }}
                  />
                  {errors.images && touched.images && (
                    <Typography
                      color={ThemeColor.RED}
                      fontSize="0.75rem"
                      fontFamily={FontFamily.Lato}
                      fontWeight={500}
                      sx={{ mt: 0.5 }}
                    >
                      {errors.images}
                    </Typography>
                  )}
                </Box>

                {/* Footer Buttons */}
                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5, mt: 1 }}>
                  <CustomButton
                    variant="outlined"
                    type="button"
                    onClick={handleClose}
                    sx={{
                      borderColor: "#CBD5E1",
                      color: "#475569",
                      "&:hover": {
                        borderColor: "#94A3B8",
                        backgroundColor: "#F8FAFC"
                      }
                    }}
                  >
                    Cancel
                  </CustomButton>
                  <CustomButton
                    variant="contained"
                    type="submit"
                    backgroundColor={ThemeColor.PURPLE}
                    color={ThemeColor.WHITE}
                    loading={formLoading}
                  >
                    Send Notification
                  </CustomButton>
                </Box>
              </Stack>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
};
